var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import Command from '../Command';
import unarchiveAsset from '../../requests/asset/unarchiveAsset';
import Signals from '../../signals/Signals';
/**
 *
 */
var UnarchiveAssetCommand = /** @class */ (function (_super) {
    __extends(UnarchiveAssetCommand, _super);
    function UnarchiveAssetCommand() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     *
     * @param organisationModel OrganisationModel
     * @param archivedAssetModel ArchivedAssetModel
     * @param arhivedAssetCollection ArchivedAssetCollection
     * @param intl
     * @return {Promise<T | never>}
     */
    UnarchiveAssetCommand.prototype.execute = function (organisationModel, archivedAssetModel, arhivedAssetCollection, intl) {
        this.arhivedAssetCollection = arhivedAssetCollection;
        this.archivedAssetModel = archivedAssetModel;
        this.intl = intl;
        return unarchiveAsset(organisationModel.id, archivedAssetModel.id).then(this.then);
    };
    /**
     *
     * @param response
     */
    UnarchiveAssetCommand.prototype.then = function (response) {
        this.arhivedAssetCollection.remove(this.archivedAssetModel);
        Signals.ShowNotification.dispatch(this.intl.formatMessage({ id: 'asset.unarchived.success' }, { assetId: this.archivedAssetModel.displayedId }), 'dark', true);
    };
    return UnarchiveAssetCommand;
}(Command));
export default UnarchiveAssetCommand;
